module.exports = __webpack_public_path__ + "static/img/416.aff7b05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/416.png
// module id = KGU1
// module chunks = 0